import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLinkIcon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import { Card } from '../components/Card';
import { TrustScore } from '../components/TrustScore';
import { cryptocurrencies } from '../data/mockData';
export function CryptocurrenciesPage() {
  return <div className="min-h-screen bg-slate-50" data-id="element-123">
      <div className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-12" data-id="element-124">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
          <h1 className="text-4xl font-bold mb-3" data-id="element-126">Top Cryptocurrencies</h1>
          <p className="text-slate-300 text-lg" data-id="element-127">
            Comprehensive reviews and trust scores for the leading
            cryptocurrencies
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-128">
        <div className="space-y-4" data-id="element-129">
          {cryptocurrencies.map(crypto => <Link key={crypto.id} to={`/cryptocurrency/${crypto.id}`} data-id="element-130">
              <Card className="p-5" hover data-id="element-131">
                <div className="flex flex-col lg:flex-row lg:items-center gap-6" data-id="element-132">
                  {/* Logo & Name */}
                  <div className="flex items-center gap-4 lg:w-64" data-id="element-133">
                    <div className="flex items-center gap-3" data-id="element-134">
                      <span className="text-slate-500 font-semibold text-sm w-6" data-id="element-135">
                        {crypto.rank}
                      </span>
                      <img src={crypto.logo} alt={crypto.name} className="w-10 h-10 flex-shrink-0" data-id="element-136" />
                    </div>
                    <div data-id="element-137">
                      <h3 className="font-semibold text-lg mb-1" data-id="element-138">
                        {crypto.name}
                      </h3>
                      <span className="text-slate-500 font-medium" data-id="element-139">
                        {crypto.symbol}
                      </span>
                    </div>
                  </div>

                  {/* Trust Score */}
                  <div className="lg:w-32" data-id="element-140">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-141">
                      Trust Score
                    </div>
                    <TrustScore score={crypto.trustScore} data-id="element-142" />
                  </div>

                  {/* Price */}
                  <div className="lg:w-40" data-id="element-143">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-144">Price</div>
                    <div className="font-semibold text-lg" data-id="element-145">
                      ${crypto.price.toLocaleString()}
                    </div>
                  </div>

                  {/* 24h Change */}
                  <div className="lg:w-32" data-id="element-146">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-147">
                      24h Change
                    </div>
                    <div className={`flex items-center gap-1 font-semibold ${crypto.change24h >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-148">
                      {crypto.change24h >= 0 ? <TrendingUpIcon size={16} data-id="element-149" /> : <TrendingDownIcon size={16} data-id="element-150" />}
                      <span data-id="element-151">
                        {crypto.change24h >= 0 ? '+' : ''}
                        {crypto.change24h.toFixed(2)}%
                      </span>
                    </div>
                  </div>

                  {/* Market Cap */}
                  <div className="lg:w-40" data-id="element-152">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-153">
                      Market Cap
                    </div>
                    <div className="font-medium" data-id="element-154">
                      ${(crypto.marketCap / 1000000000).toFixed(1)}B
                    </div>
                  </div>

                  {/* Volume */}
                  <div className="lg:w-40" data-id="element-155">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-156">
                      24h Volume
                    </div>
                    <div className="font-medium" data-id="element-157">
                      ${(crypto.volume24h / 1000000000).toFixed(1)}B
                    </div>
                  </div>

                  {/* Reviews */}
                  <div className="lg:w-32 lg:ml-auto" data-id="element-158">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-159">Reviews</div>
                    <div className="font-medium" data-id="element-160">
                      {crypto.reviews.length} reviews
                    </div>
                  </div>
                </div>
              </Card>
            </Link>)}
        </div>
      </div>
    </div>;
}